import React from 'react'
import { useTheme, IconButton, ClickAwayListener, Popper } from '@mui/material'
import { Sms } from 'iconsax-react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import Tooltip from '@SonarCX/components/atoms/Tooltip'
import NewCount from '../BaseConversation/NewCount'
import Email from './Email'

import { selectExtensionAPI } from '@SonarCX/slices/extensionAPI'
import useStyles from './styles'

const EmailHolder: React.FC = () => {
  const theme = useTheme()

  const { emails: emailsDict } = useAppSelector(selectExtensionAPI)
  const emails = React.useMemo(() => Object.values(emailsDict), [emailsDict])

  const rootRef = React.useRef(null)
  const [anchor, setAnchor] = React.useState<null | Element>(null)
  const isOpen = React.useMemo(() => Boolean(anchor), [anchor])

  const classes = useStyles()

  const handleClick = React.useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
    setAnchor(e.currentTarget)
  }, [])

  const handleClose = React.useCallback(() => {
    setAnchor(null)
  }, [])

  return (
    <>
      <div className={classes.root}>
        <Tooltip title='Emails' arrow>
          <IconButton onClick={handleClick} className={classes.iconRoot}>
            <Sms size={theme.size.lg} color='black' />
          </IconButton>
        </Tooltip>

        {emails.length > 0 && (
          <NewCount count={emails.length} className={classes.count} />
        )}
      </div>

      <ClickAwayListener onClickAway={handleClose}>
        <div ref={rootRef} onClick={handleClick}>
          <Popper
            open={isOpen}
            anchorEl={anchor}
            placement='bottom-start'
            style={{ zIndex: '1500' }}
          >
            <div className={classes.menu}>
              <div className={classes.menuRoot}>
                {emails.length === 0 && <div>No emails</div>}

                <div className={classes.emails}>
                  {emails.map(email => (
                    <Email key={email.id} wrapped={email} />
                  ))}
                </div>
              </div>
            </div>
          </Popper>
        </div>
      </ClickAwayListener>
    </>
  )
}

export default EmailHolder
